import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHouseUser, faUser, faBriefcase, faPhone, faFolderOpen,
} from '@fortawesome/free-solid-svg-icons';
import { Link, useLocation } from 'react-router-dom';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const NavigationBar = () => {
  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split('/');
  return (
    <div className="header-holder">
      <div className="bg-slate-50 dark:bg-slate-800 navigation">
        <ul className="m-0">
          <li data-class="dark:text-slate-400" className="py-4 text-center text-slate-500 dark:text-slate-400 text-2xl">
            <Tippy placement="left" content="Home" className="tooltip">
              <Link to="/" className={`${splitLocation[1] === '' ? 'active' : ''}`}>
                <FontAwesomeIcon icon={faHouseUser} />
              </Link>
            </Tippy>
          </li>
          <li data-class="dark:text-slate-400" className="py-4 text-center text-slate-500 dark:text-slate-400 text-2xl">
            <Tippy placement="left" content="About" className="tooltip">
              <Link to="/about" className={`${splitLocation[1] === 'about' ? 'active' : ''}`}>
                <FontAwesomeIcon icon={faUser} />
              </Link>
            </Tippy>
          </li>
          <li data-class="dark:text-slate-400" className="py-4 text-center text-slate-500 dark:text-slate-400 text-2xl">
            <Tippy placement="left" content="Resume" className="tooltip">
              <Link to="/resume" className={`${splitLocation[1] === 'resume' ? 'active' : ''}`}>
                <FontAwesomeIcon icon={faBriefcase} />
              </Link>
            </Tippy>
          </li>
          <li data-class="dark:text-slate-400" className="py-4 text-center text-slate-500 dark:text-slate-400 text-2xl">
            <Tippy placement="left" content="Projects" className="tooltip">
              <Link to="/projects" className={`${splitLocation[1] === 'projects' ? 'active' : ''}`}>
                <FontAwesomeIcon icon={faFolderOpen} />
              </Link>
            </Tippy>
          </li>
          <li data-class="dark:text-slate-400" className="py-4 text-center text-slate-500 dark:text-slate-400 text-2xl">
            <Tippy placement="left" content="Contact" className="tooltip">
              <Link to="/contact" className={`${splitLocation[1] === 'contact' ? 'active' : ''}`}>
                <FontAwesomeIcon icon={faPhone} />
              </Link>
            </Tippy>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default NavigationBar;
